import React, { useEffect, useState } from "react";
import ContentBoxMUI from "../../Components/ContentBoxMUI";
import "./taskfolder.css";
import Typography from "@mui/material/Typography";
import TaskImage from "./TaskImage";
import TaskFolderImageModal from "./TaskFolderImageModal";
import { ServerApi } from "../../internal";
import Skeleton from "@mui/material/Skeleton";
import html2pdf from "html2pdf.js";
import Button from "@mui/material/Button";

const TaskFolder = (props) => {
  const { location, history } = props;

  const [taskThumbnailLoaded, setTaskThumbnailLoaded] = useState(false);

  const [isNewFormat, setIsNewFormat] = useState(false);
  const [backResponse, setbackResponse] = useState();
  const [newItems, setNewItems] = useState([]);
  const [openImage, setOpenImage] = useState(null);

  useEffect(() => {
    if (!location || !location.state || !location.state.folder) {
      history.push("/");
    }
  }, [location, history]);

  useEffect(() => {
    if (
      !taskThumbnailLoaded &&
      location &&
      location.state &&
      location.state.folder
    ) {
      fetchTaskThumbnail(
        location,
        setTaskThumbnailLoaded,
        setIsNewFormat,
        setbackResponse,
        setNewItems,
      );
    }
  }, [taskThumbnailLoaded, location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const printToPDF = async () => {
    const source = document.getElementById("pdfdiv");
    if (!source) return;

    // html2canvas can't rasterize <video>/<audio> and often fails to capture cross-origin
    // (S3 signed URL) <img> sources, so a sanitized offscreen clone is built and captured instead.
    const clone = source.cloneNode(true);
    clone.style.position = "fixed";
    clone.style.left = "-100000px";
    clone.style.top = "0";
    clone.style.background = "#ffffff";
    clone.style.width = `${Math.max(720, Math.ceil(source.getBoundingClientRect().width))}px`;
    document.body.appendChild(clone);

    try {
      await preparePdfExportClone(clone);

      var options = {
        pagebreak: { mode: "avoid-all" },
        filename: `${location.state.folder.Name}.pdf`,
        margin: [10, 15],
        html2canvas: { useCORS: true, allowTaint: false, scale: 2 },
      };
      await html2pdf(clone, options);
    } finally {
      document.body.removeChild(clone);
    }
  };

  if (!location || !location.state || !location.state.folder) {
    return null;
  }

  return (
    <div>
      <ContentBoxMUI>
        <div id="pdfdiv" className="TaskFolderContainer">
          <div className="TaskFolderDescription">
            {location.state.folder.Description}
            <hr />
          </div>
          {!taskThumbnailLoaded ? (
            <div>
              <div className="taskMarginBottom">
                <Skeleton variant="rectangular" height={250}></Skeleton>
              </div>
              <div className="taskMarginBottom">
                <Skeleton variant="rectangular" height={250}></Skeleton>
              </div>
              <div className="taskMarginBottom">
                <Skeleton variant="rectangular" height={250}></Skeleton>
              </div>
            </div>
          ) : isNewFormat ? (
            newItems.length === 0 ? (
              <Typography>Tämä teemakansio on tyhjä.</Typography>
            ) : (
              newItems.map((item) => (
                <div className="TaskFolderContainer" key={item.Id}>
                  {item.ItemType === "header" ? (
                    <div className="taskTitle">
                      <Typography variant="h5">
                        <b>{item.Header}</b>
                      </Typography>
                    </div>
                  ) : null}
                  {item.ItemType === "text" ? (
                    <div className="taskDesc">
                      <div
                        className="taskDescTextCenter"
                        dangerouslySetInnerHTML={{ __html: item.Text }}
                      ></div>
                    </div>
                  ) : null}
                  {item.ItemType === "image" ? (
                    <div className="taskImage">
                      <div className="wrapper">
                        <img
                          src={item.ThumbnailUrl || item.ContentUrl}
                          alt="Tehtäväkuva"
                          onClick={() => setOpenImage(item.ContentUrl)}
                        />
                      </div>
                    </div>
                  ) : null}
                  {item.ItemType === "video" ? (
                    <div className="taskImage">
                      <video
                        className="taskVideo"
                        src={item.ContentUrl}
                        poster={item.ThumbnailUrl}
                        controls
                        preload="metadata"
                      />
                    </div>
                  ) : null}
                  {item.ItemType === "audio" ? (
                    <div className="taskAudio">
                      <audio
                        src={item.ContentUrl}
                        controls
                        preload="metadata"
                      />
                    </div>
                  ) : null}
                  {item.Text && item.ItemType !== "text" ? (
                    <div className="taskDesc">
                      <div
                        className="taskDescTextCenter"
                        dangerouslySetInnerHTML={{ __html: item.Text }}
                      ></div>
                    </div>
                  ) : null}
                  <hr />
                </div>
              ))
            )
          ) : (
            backResponse.map((task) => {
              return task.Published ? (
                <div className="TaskFolderContainer" key={task.Id.toString()}>
                  <div className="taskTitle">
                    {task.Header !== "NULL" ? (
                      <Typography variant="h5">
                        <b>{task.Header}</b>
                      </Typography>
                    ) : null}
                  </div>
                  {task.Data ? (
                    <div className="taskImage">
                      <TaskImage
                        image={
                          "data:" +
                          task.MimeType +
                          ";base64," +
                          task.DataThumbnail
                        }
                        fullimage={
                          "data:" + task.MimeType + ";base64," + task.Data
                        }
                        downloadData={task.Data}
                        downloadMimeType={task.MimeType}
                        downloadFileName={task.FileName}
                      />
                    </div>
                  ) : null}
                  {task.ImgDescription !== "NULL" ? (
                    <div className="taskDesc">
                      <div className="taskDescTextCenter">
                        <Typography>{task.ImgDescription}</Typography>
                      </div>
                    </div>
                  ) : null}
                  <hr />
                </div>
              ) : null;
            })
          )}
        </div>
      </ContentBoxMUI>
      {openImage ? (
        <TaskFolderImageModal
          image={openImage}
          onCloseRequest={() => setOpenImage(null)}
        />
      ) : null}
    </div>
  );
};

const fetchTaskThumbnail = async (
  location,
  setTaskThumbnailLoaded,
  setIsNewFormat,
  setbackResponse,
  setNewItems,
) => {
  const childId = location.state.childId;
  const folderId = location.state.folder.Id;

  const newFormatResponse = await new ServerApi().loadTaskFolderItems(
    childId,
    folderId,
  );
  if (
    newFormatResponse.status === 200 &&
    newFormatResponse.data &&
    newFormatResponse.data.IsNewFormat
  ) {
    setIsNewFormat(true);
    setNewItems(newFormatResponse.data.Items || []);
    setTaskThumbnailLoaded(true);
    return;
  }

  const response = await new ServerApi().loadTaskThumbnail(childId, folderId);
  setIsNewFormat(false);
  setbackResponse(response.data);
  setTaskThumbnailLoaded(true);
};

// html2canvas can't render <video>, so swap each one for its poster thumbnail in the PDF clone.
const replaceVideosWithPosters = (root) => {
  Array.from(root.querySelectorAll("video")).forEach((video) => {
    const posterSrc = video.getAttribute("poster");
    if (!posterSrc) {
      video.remove();
      return;
    }
    const img = document.createElement("img");
    img.setAttribute("src", posterSrc);
    img.setAttribute("alt", "");
    img.className = "taskVideo";
    video.replaceWith(img);
  });
};

// Audio has no visual representation; swap it for a text placeholder in the PDF clone.
const replaceAudioWithPlaceholders = (root) => {
  Array.from(root.querySelectorAll("audio")).forEach((audio) => {
    const label = document.createElement("div");
    label.className = "taskAudioPdfPlaceholder";
    label.textContent = "♫ Äänite (ei toistettavissa PDF:ssä)";
    audio.replaceWith(label);
  });
};

const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () =>
      reject(new Error("Unable to convert blob to data url"));
    reader.readAsDataURL(blob);
  });

const waitForImage = (img) => {
  if (img.complete && img.naturalWidth > 0) return Promise.resolve();
  return new Promise((resolve) => {
    const done = () => {
      img.removeEventListener("load", done);
      img.removeEventListener("error", done);
      resolve();
    };
    img.addEventListener("load", done);
    img.addEventListener("error", done);
  });
};

// Signed S3 URLs are cross-origin, so fetch+inline them as data URLs before capture; legacy
// base64 data: images are left untouched.
const inlineImages = async (root) => {
  const images = Array.from(root.querySelectorAll("img"));
  await Promise.all(
    images.map(async (img) => {
      const src = img.getAttribute("src");
      if (src && !src.startsWith("data:")) {
        try {
          const response = await fetch(src, { cache: "no-store" });
          if (response.ok) {
            img.src = await blobToDataUrl(await response.blob());
          }
        } catch {
          // Keep the original URL if inline conversion fails.
        }
      }
      await waitForImage(img);
    }),
  );
};

const preparePdfExportClone = async (root) => {
  replaceVideosWithPosters(root);
  replaceAudioWithPlaceholders(root);
  await inlineImages(root);
};

export default TaskFolder;
